import { useEffect } from 'react';

import { Announcement } from '@web/announcements/types/Announcement';
import { useParsedContent } from '@web/common/hooks/useParsedContent';

import { useMarkAnnouncementAsRead } from './../hooks/useMarkAnnouncementAsRead';

export const useAnnouncementInnerContent = (announcement: Announcement) => {
  const { mutate } = useMarkAnnouncementAsRead();
  const parsedContent = useParsedContent(announcement.description, null);

  useEffect(() => {
    if (!announcement.isRead) {
      mutate(announcement.id);
    }
  }, [announcement.id, announcement.isRead, mutate]);

  return {
    parsedContent,
  };
};
